import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import LogoWall from "../components/LogoWall";
import About from "../components/About";
import Services from "../components/Services";
import Stats from "../components/Stats";
import Portfolio from "../components/Portfolio";
import Assessment from "../components/Assessment";
import Pricing from "../components/Pricing";
import Testimonials from "../components/Testimonials";
import Journal from "../components/Journal";
import Booking from "../components/Booking";
import Contact from "../components/Contact";
import ChatWidget from "../components/ChatWidget";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if (a) {
        const href = a.getAttribute("href");
        if (href && href.length > 1) {
          const el = document.querySelector(href);
          if (el) {
            e.preventDefault();
            lenis.scrollTo(el, { offset: -64 });
          }
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain">
      <Nav />
      <main className="relative">
        <Hero />
        <LogoWall />
        <About />
        <Services />
        <Stats />
        <Portfolio />
        <Assessment />
        <Pricing />
        <Testimonials />
        <Journal />
        <Booking />
      </main>
      <Contact />
      <ChatWidget />
    </div>
  );
}
